import { DELETE_INTEGRATION } from './index'

export const requestDeleteIntegration = (payload) => ({
  type: DELETE_INTEGRATION.REQUEST,
  payload,
})

export const successDeleteIntegration = (payload) => ({
  type: DELETE_INTEGRATION.SUCCESS,
  payload,
})

export const errorDeleteIntegration = (payload) => ({
  type: DELETE_INTEGRATION.ERROR,
  payload,
})
